import AppHeaderSubtitle, { AppHeaderSubtitleProps } from './AppHeaderSubtitle';

export default AppHeaderSubtitle;
export type { AppHeaderSubtitleProps };
